import { ReactNode } from "react";

export type DlGroup = {
  slug: string;
  linkLabel: ReactNode;
  linkLabelMob: string;
};

export const DL_GROUPS: Record<string, DlGroup> = {
  "petar-lubarda": {
    slug: "petar-lubarda",
    linkLabel: <>PETAR LUBARDA</>,
    linkLabelMob: "PETAR LUBARDA",
  },
  "sava-sumanovic": {
    slug: "sava-sumanovic",
    linkLabel: <>SAVA ŠUMANOVIĆ</>,
    linkLabelMob: "SAVA ŠUMANOVIĆ",
  },
  "nadezda-petrovic": {
    slug: "nadezda-petrovic",
    linkLabel: <>NADEŽDA PETROVIĆ</>,
    linkLabelMob: "NADEŽDA PETROVIĆ",
  },
  "muzej-savremene-umetnosti": {
    slug: "muzej-savremene-umetnosti",
    linkLabel: (
      <>
        MUZEJ
        <br />
        SAVREMENE
        <br />
        UMETNOSTI
      </>
    ),
    linkLabelMob: "MUZEJ SAVREMENE UMETNOSTI",
  },
  avangarda: {
    slug: "avangarda",
    linkLabel: <>AVANGARDA</>,
    linkLabelMob: "AVANGARDA",
  },
  "oktobarski-salon": {
    slug: "oktobarski-salon",
    linkLabel: <>OKTOBARSKI SALON</>,
    linkLabelMob: "OKTOBARSKI SALON",
  },
  "konceptualna-umetnost": {
    slug: "konceptualna-umetnost",
    linkLabel: <>KONCEPTUALNA UMETNOST</>,
    linkLabelMob: "KONCEPTUALNA UMETNOST",
  },
};
